import { useTranslation } from "@/i18n/useTranslation";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="py-8 border-t border-border/60 bg-background">
      <div className="container mx-auto px-4 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="font-display font-bold text-foreground tracking-tight">
          East<span className="text-gradient">West</span>IT
        </p>
        <p className="text-sm text-muted-foreground font-body">
          © {new Date().getFullYear()} EastWest IT (DK43969803). {t.footer.rights}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
